import * as searchJobsHorizonRouteExports from '#/modules/search/jobs/page/SearchJobs.horizon-route';
import { horizonRouteToObject } from '#/routing/utils/horizonRouteToObject';

import { searchJobsRoutePaths } from './searchJobs.route-paths';

export const searchJobsRouteObjects = searchJobsRoutePaths.map((path) => ({
  path,
  ...horizonRouteToObject(searchJobsHorizonRouteExports),
}));
